import { createContext, useContext } from 'react';
import { DepartmentFormType } from 'pages/get-started/add-department';
import { FileDetailsType } from 'pages/get-started/add-your-team/add-csv-file';
import { ActiveType } from 'pages/get-started/add-your-team';
import { BranchAddressLocationType } from 'models/branch-address.model';
import { OperatingDaysFormDataType } from 'models/operating-day.model';
import { AddBrandType } from 'models/brand.model';
import { ENUM_WORK_MODES } from 'utils/enum';

export type CardDetailsType = {
  text: string;
  id: string;
};

export type GetStartedActionsContextType = {
  showTransferModal: boolean;
  setshowTransferModal: (item: boolean) => void;
  departmentFormData: DepartmentFormType[];
  setDepartmentFormData: (value: DepartmentFormType[]) => void;
  teamDataForm: FileDetailsType[];
  setTeamDataForm: (Value: FileDetailsType[]) => void;
  isDisabled: boolean;
  setIsDisabled: (item: boolean) => void;
  isFormEmpty: boolean;
  setIsFormEmpty: (item: boolean) => void;
  active: ActiveType | null;
  setActive: (item: ActiveType | null) => void;
  brandFormData: AddBrandType;
  setBrandFormData: (data: AddBrandType) => void;
  addressesFormData: BranchAddressLocationType[];
  setAddressesFormData: (a: BranchAddressLocationType[]) => void;
  operatingDays: OperatingDaysFormDataType;
  setOperatingDays: (d: OperatingDaysFormDataType) => void;
  workModes: ENUM_WORK_MODES[];
  setWorkModes: (w: ENUM_WORK_MODES[]) => void;
};

export const GetStartedActionsContext = createContext({} as GetStartedActionsContextType);

const useGetStartedActionsContext = () => {
  const context = useContext(GetStartedActionsContext);
  return context;
};

export default useGetStartedActionsContext;
